export type PodStatus = "pending" | "partial" | "delivered";

export type DeliveryStopPodStatusInput = {
  delivered_at: string | null | undefined;
};

export const POD_STATUS_MESSAGE_IDS = {
  pending: "components.molecules.top-nav.deliveryStopPodStatus.noPodYet",
  partial: "components.molecules.top-nav.deliveryStopPodStatus.partialPod",
  delivered: "components.molecules.top-nav.deliveryStopPodStatus.delivered",
} as const;

export function mapDeliveredAtToStopStatus(deliveredAt: string | null | undefined): Exclude<PodStatus, "partial"> {
  return deliveredAt ? "delivered" : "pending";
}

export function mapStopsToMasterPodStatus(stops: DeliveryStopPodStatusInput[]): PodStatus {
  if (stops.length === 0) {
    return "pending";
  }

  const deliveredCount = stops.filter((stop) => Boolean(stop.delivered_at)).length;

  if (deliveredCount === 0) {
    return "pending";
  }

  if (deliveredCount === stops.length) {
    return "delivered";
  }

  return "partial";
}

export function getPodStatusMessageId(status: PodStatus): string {
  return POD_STATUS_MESSAGE_IDS[status];
}
